export default __webpack_public_path__ + "static/ab-online-fd840e90ed190cc6d619b54268e1045b.jpg";